import React from 'react';
import { Check } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-gray-50" data-id="element-211">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-212">
        <div className="text-center mb-16" data-id="element-213">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-214">
            Simple Pricing. No Markup on Your LLM Costs.
          </h2>
          <p className="text-lg text-gray-600" data-id="element-215">
            We never markup your LLM costs. You set your margin, pay us a flat
            fee, keep 100% of your profit.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-216">
          {/* Free */}
          <div className="bg-white p-8 rounded-2xl border border-gray-200 flex flex-col" data-id="element-217">
            <div className="mb-8" data-id="element-218">
              <h3 className="text-lg font-bold text-gray-900" data-id="element-219">Free</h3>
              <div className="mt-4 flex items-baseline" data-id="element-220">
                <span className="text-4xl font-extrabold text-gray-900" data-id="element-221">
                  $0
                </span>
                <span className="ml-1 text-gray-500" data-id="element-222">/month</span>
              </div>
              <p className="mt-2 text-sm text-gray-500" data-id="element-223">
                Perfect for testing and side projects
              </p>
            </div>
            <ul className="space-y-4 mb-8 flex-grow" data-id="element-224">
              <li className="flex items-center gap-3 text-sm text-gray-600" data-id="element-225">
                <Check className="w-5 h-5 text-green-500" data-id="element-226" /> 1 project
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-600" data-id="element-227">
                <Check className="w-5 h-5 text-green-500" data-id="element-228" /> 10K requests/month
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-600" data-id="element-229">
                <Check className="w-5 h-5 text-green-500" data-id="element-230" /> All integrations
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-600" data-id="element-231">
                <Check className="w-5 h-5 text-green-500" data-id="element-232" /> Community support
              </li>
            </ul>
            <a href="https://us.posthog.com/external_surveys/019da0fa-860d-0000-f825-d448b1152f42" target="_blank" rel="noopener noreferrer" className="w-full py-3 px-4 bg-gray-50 text-gray-900 font-bold rounded-xl hover:bg-gray-100 transition-colors text-center" data-id="element-233">
              Start Free
            </a>
          </div>

          {/* Pro */}
          <div className="bg-white p-8 rounded-2xl border-2 border-blue-600 flex flex-col relative shadow-xl shadow-blue-100" data-id="element-234">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-235">
              Most Popular
            </div>
            <div className="mb-8" data-id="element-236">
              <h3 className="text-lg font-bold text-gray-900" data-id="element-237">Pro</h3>
              <div className="mt-4 flex items-baseline" data-id="element-238">
                <span className="text-4xl font-extrabold text-gray-900" data-id="element-239">
                  $49
                </span>
                <span className="ml-1 text-gray-500" data-id="element-240">/month</span>
              </div>
              <p className="mt-2 text-sm text-gray-500" data-id="element-241">
                For startups and indie developers
              </p>
            </div>
            <ul className="space-y-4 mb-8 flex-grow" data-id="element-242">
              <li className="flex items-center gap-3 text-sm text-gray-600 font-medium" data-id="element-243">
                <Check className="w-5 h-5 text-green-500" data-id="element-244" /> Unlimited projects
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-600" data-id="element-245">
                <Check className="w-5 h-5 text-green-500" data-id="element-246" /> 1M requests/month
                ($5 per extra 1M)
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-600" data-id="element-247">
                <Check className="w-5 h-5 text-green-500" data-id="element-248" /> Advanced routing
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-600" data-id="element-249">
                <Check className="w-5 h-5 text-green-500" data-id="element-250" /> Usage analytics
                dashboard
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-600" data-id="element-251">
                <Check className="w-5 h-5 text-green-500" data-id="element-252" /> Priority support
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-600" data-id="element-253">
                <Check className="w-5 h-5 text-green-500" data-id="element-254" /> Custom domain
              </li>
            </ul>
            <button className="w-full py-3 px-4 bg-blue-600 text-white font-bold rounded-xl hover:bg-blue-700 transition-colors shadow-lg shadow-blue-200" data-id="element-255">
              Get Pro
            </button>
          </div>

          {/* Enterprise */}
          <div className="bg-white p-8 rounded-2xl border border-gray-200 flex flex-col" data-id="element-256">
            <div className="mb-8" data-id="element-257">
              <h3 className="text-lg font-bold text-gray-900" data-id="element-258">Enterprise</h3>
              <div className="mt-4 flex items-baseline" data-id="element-259">
                <span className="text-4xl font-extrabold text-gray-900" data-id="element-260">
                  Custom
                </span>
              </div>
              <p className="mt-2 text-sm text-gray-500" data-id="element-261">
                For high-volume & regulated industries
              </p>
            </div>
            <ul className="space-y-4 mb-8 flex-grow" data-id="element-262">
              <li className="flex items-center gap-3 text-sm text-gray-600" data-id="element-263">
                <Check className="w-5 h-5 text-green-500" data-id="element-264" /> Everything in Pro
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-600" data-id="element-265">
                <Check className="w-5 h-5 text-green-500" data-id="element-266" /> Unlimited requests
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-600" data-id="element-267">
                <Check className="w-5 h-5 text-green-500" data-id="element-268" /> Self-hosted / VPC
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-600" data-id="element-269">
                <Check className="w-5 h-5 text-green-500" data-id="element-270" /> White-label
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-600" data-id="element-271">
                <Check className="w-5 h-5 text-green-500" data-id="element-272" /> Dedicated support
              </li>
              <li className="flex items-center gap-3 text-sm text-gray-600" data-id="element-273">
                <Check className="w-5 h-5 text-green-500" data-id="element-274" /> 99.99% SLA
              </li>
            </ul>
            <button className="w-full py-3 px-4 bg-gray-900 text-white font-bold rounded-xl hover:bg-black transition-colors" data-id="element-275">
              Talk to Sales
            </button>
          </div>
        </div>
      </div>
    </section>;
}